import { createContext, useContext } from "react";
import { useCreOrganisationHeader } from "./hooks/useCreOrganisationHeader";
import CreOrganisationModal from "./CreOrganisationModal";
import CreOrganisationPicker from "./CreOrganisationPicker";
import "./cre.css";

const CreOrganisationHeaderContext = createContext(null);

const HEADER_CHIP_CLASS =
  "cre-org-header-chip h-10 min-h-[44px] px-2.5 sm:px-3 rounded-full text-[11px] sm:text-xs font-semibold max-w-[min(260px,55vw)] truncate inline-flex items-center";

export function CreOrganisationHeaderProvider({ children }) {
  const value = useCreOrganisationHeader();
  return (
    <CreOrganisationHeaderContext.Provider value={value}>
      {children}
    </CreOrganisationHeaderContext.Provider>
  );
}

function useCreOrganisationHeaderContext() {
  return useContext(CreOrganisationHeaderContext);
}

export function CreOrganisationHeaderModals() {
  const ctx = useCreOrganisationHeaderContext();
  if (!ctx) return null;

  const { needsInitialPick, switchModalOpen, canSwitch, closeSwitchModal } =
    ctx;

  return (
    <>
      <CreOrganisationModal open={needsInitialPick} required>
        <CreOrganisationPicker subtitle="Choose which organisation you are working in. Your choice is remembered on this device." />
      </CreOrganisationModal>

      {canSwitch ? (
        <CreOrganisationModal
          open={switchModalOpen}
          onClose={closeSwitchModal}
          required={false}
        >
          <CreOrganisationPicker
            title="Switch organisation"
            subtitle="Choose which organisation you are working in. Process with AI will use your selection."
            continueLabel="Apply"
            showCancel
            onCancel={closeSwitchModal}
            onContinue={closeSwitchModal}
          />
        </CreOrganisationModal>
      ) : null}
    </>
  );
}

export function CreOrganisationHeaderChip() {
  const ctx = useCreOrganisationHeaderContext();
  if (!ctx?.isVisible) return null;

  const { label, canSwitch, openSwitchModal } = ctx;

  if (canSwitch) {
    return (
      <button
        type="button"
        className={`${HEADER_CHIP_CLASS} cre-org-header-chip--interactive`}
        title={label}
        onClick={openSwitchModal}
      >
        Org: {label}
      </button>
    );
  }

  return (
    <span className={HEADER_CHIP_CLASS} title={label}>
      Org: {label}
    </span>
  );
}
